import { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useAccessInfo } from '../contexts/AccessTokenProvider';
import { hasEmployeePortalAccess, PortalContextKind } from '../models/portal-context';

const EmployeePortalContextEntry = () => {
    const location = useLocation();
    const { accessInfo, changePortalContext } = useAccessInfo();
    const [failed, setFailed] = useState(false);
    const available = hasEmployeePortalAccess(accessInfo.portalAccess);

    useEffect(() => {
        if (!available || accessInfo.currentPortalContext?.Kind === PortalContextKind.Employee)
            return;
        let active = true;
        changePortalContext({ Kind: PortalContextKind.Employee })
            .catch(() => active && setFailed(true));
        return () => { active = false; };
    }, [accessInfo.currentPortalContext, available, changePortalContext]);

    if (!available)
        return <Redirect to="/" />;
    if (failed)
        return <Box sx={{ p: 3 }}><Alert severity="error">Your personal development portal is not available. It may have been revoked. Return to an authorized workspace or sign out.</Alert></Box>;
    if (accessInfo.currentPortalContext?.Kind !== PortalContextKind.Employee)
        return <Box role="status" aria-live="polite" sx={{ minHeight: 240, display: 'grid', placeItems: 'center' }}><CircularProgress aria-label="Opening personal development portal" /></Box>;
    return <Redirect to={`${location.pathname}${location.search}`} />;
};

export default EmployeePortalContextEntry;
